<template>
  <div class="chats">
    <div
      v-for="(msgGrp, index) in formattedChatData.formattedChatLog"
      :key="msgGrp.senderId + String(index)"
      class="chat"
      :class="{
        'chat-left': formattedChatData.contact.id
          ? msgGrp.senderId == formattedChatData.contact.id
          : msgGrp.senderId != formattedChatData.contact.id_user,
      }"
    >
      <div class="chat-avatar">
        <b-avatar
          size="35"
          class="avatar-border-2 box-shadow-1"
          variant="secondary"
          :src="
            msgGrp.senderId === formattedChatData.contact.id
              ? formattedChatData.contact.avatar
              : chatData.image
          "
        />
      </div>
      <div class="chat-body" v-if="!formattedChatData.contact.id_user">

        <div v-for="msgData in msgGrp.messages" :key="msgData.time" class="chat-content" style="word-wrap: break-word">
          <p class="text-muted">{{ msgData.msg }}</p>
          <small style="float: right;" class="text-muted">
            {{
              formatDateToMonthShort(msgData.time, {
                hour: "numeric",
                minute: "numeric",
              })
            }} 
          </small>
        </div>
      </div>

      <div class="chat-body" v-if="formattedChatData.contact.id_user">
        <div v-for="msgData in msgGrp.messages" :key="msgData.time">
          <div v-if="msgData.t" style="float: right; width: 100%;">
            <span class="text-muted">{{ msgData.user }}</span>
            <p :class="msgData.t == 'au' ? 'alert alert-success' : 'alert alert-danger'">
              {{
                msgData.t == "au"
                  ? `${$t("chat.added")} ` + msgData.is_added
                  : `${$t("chat.eliminated")} ` + msgData.is_added
              }}
            </p>
          </div>
          <div v-else class="chat-content" style="word-wrap: break-word">
            <span class="text-muted">{{ msgData.user }}</span>
            <p class="text-muted">{{ msgData.msg }}</p>
            <small style="float: right;" class="text-muted">
              {{
                formatDateToMonthShort(msgData.time, {
                  hour: "numeric",
                  minute: "numeric",
                })
              }} 
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import { BAvatar } from "bootstrap-vue";
import { getUserData } from "@/auth/utils";
import { formatDateToMonthShort } from "@core/utils/filter";

export default {
  components: {
    BAvatar,
  },
  props: {
    chatData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const formattedChatData = computed(() => {
      let userData = getUserData();

      let contact = {
        id: props.chatData.id,
        avatar: props.chatData.image,
      };

      if(props.chatData.isFromApp){
        contact.id = null;
      }

      if (props.chatData.roomId) {
        contact.id_user = userData.id;
      }

      let chatLog = [];
      if (props.chatData) {
        chatLog = props.chatData.messages;
      }

      const formattedChatLog = [];
      let chatMessageSenderId = userData.id;

      let msgGroup = {
        sender: chatMessageSenderId,
        messages: [],
      };

      chatLog.forEach((msg, index) => {
        let userId = msg.username.split("_")[1];
        if (chatMessageSenderId == userId) {
          msgGroup.messages.push({
            msg: msg.text,
            time: msg.ts,
            user: msg.name,
            t: msg.t,
            is_added: msg.is_added
          });
        } else {
          chatMessageSenderId = userId;
          if (msgGroup.messages.length > 0) {
            formattedChatLog.push(msgGroup);
          }
          
          msgGroup = {
            senderId: userId,
            messages: [
              {
                msg: msg.text,
                time: msg.ts,
                user: msg.name,
                t: msg.t,
                is_added: msg.is_added
              },
            ],
          };
        }
        if (index === chatLog.length - 1) formattedChatLog.push(msgGroup);
      });

      return {
        formattedChatLog,
        contact,
      };
    });

    return {
      formattedChatData,
      formatDateToMonthShort,
    };
  },
};
</script>

<style></style>
